import { render, staticRenderFns } from "./expenses-general-purchase.vue?vue&type=template&id=caaebf98"
import script from "./expenses-general-purchase.vue?vue&type=script&lang=js"
export * from "./expenses-general-purchase.vue?vue&type=script&lang=js"
import style0 from "./expenses-general-purchase.vue?vue&type=style&index=0&id=caaebf98&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports